import React from "react";
import { useNavigate } from "react-router-dom";

//Third Party
import { useTable, useSortBy, useFilters } from "react-table";
import { useExportData } from "react-table-plugins";
import "jspdf-autotable";
//Styles
import "../../../../_metronic/assets/sass/components/CustomTable.scss";
import { KTIcon } from "../../../../_metronic/helpers";
import { convertSDate } from "../../../../_metronic/helpers/utils";
import { ButtonWithoutIcon, CustomPagination, Status } from "../lib";
import { saleStatus } from "../../../CONSTANTS";

interface LeaguesListTableProps {
  data: any; // Replace 'any' with the appropriate type for your data
  queryString: any;
  setQueryString: any;
  refetch: () => void;
  numberInPage: number | string;
}

const LotteryTabel = ({
  data,
  queryString,
  setQueryString,
  refetch,
  numberInPage,
}: LeaguesListTableProps) => {
  let matchId: any = "";

  const navigate = useNavigate();
  // Define a default UI for filtering
  function DefaultColumnFilter({
    column: { filterValue, preFilteredRows, setFilter },
  }) {
    const count = preFilteredRows.length;

    return (
      <input
        value={filterValue || ""}
        onChange={(e) => {
          setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
        }}
        placeholder={`Search ${count} records...`}
      />
    );
  }

  const defaultColumn = {
    Filter: DefaultColumnFilter,
  };

  let columns = React.useMemo(
    () => [
      {
        Header: <HeaderTextIcon text={"ردیف"} />,
        accessor: "id",
        Cell: ({ value }) => <span className={"rowNum"}>{value}</span>,
      },
      {
        Header: <HeaderTextIcon text={"تیم میزبان"} />,
        accessor: "homeTeam.nameFA",
      },
      {
        Header: <HeaderTextIcon text={"تیم مهمان"} />,
        accessor: "awayTeam.nameFA",
      },
      {
        Header: <HeaderTextIcon text={"تاریخ بازی"} />,
        accessor: "matchDate",
        Cell: ({ value }) => <span>{convertSDate(value)}</span>,
      },
      // {
      //   Header: <HeaderTextIcon text={"تعداد بلیط های قابل فروش"} />,
      //   accessor: "summary.availableTickets",
      //   Cell: ({ value, row }) => (
      //     <span>{row.original.status !== "future" ? value : "---"}</span>
      //   ),
      // },
      // {
      //   Header: <HeaderTextIcon text={"تعداد بلیط های فروش رفته"} />,
      //   accessor: "summary.soldTickets",
      //   Cell: ({ value, row }) => (
      //     <span>{row.original.status !== "future" ? value : "---"}</span>
      //   ),
      // },
      // {
      //   Header: <HeaderTextIcon text={"ارزش ریالی قابل فروش"} />,
      //   accessor: "summary.totalValue",
      //   Cell: ({ value, row }) => (
      //     <span dir={"rtl"}>
      //       {row.original.status !== "future"
      //         ? formatRiTTo(value) + "تومان"
      //         : "---"}
      //     </span>
      //   ),
      // },
      // {
      //   Header: <HeaderTextIcon text={"ارزش ریالی فروخته شده"} />,
      //   accessor: "summary.soldValue",
      //   Cell: ({ value, row }) => (
      //     <span dir={"rtl"}>
      //       {row.original.status !== "future"
      //         ? formatRiTTo(value) + "تومان"
      //         : "---"}
      //     </span>
      //   ),
      // },

      {
        Header: <HeaderTextIcon text={"وضعیت"} />,
        accessor: "status",
        Cell: ({ value }) => (
          <Status className={saleStatus[value]?.className}>
            {saleStatus[value].children}
          </Status>
        ),
      },
      {
        Header: "",
        accessor: "actions",
        Cell: ({ value, row }) => {
          return (
            <>
              {row.original.status !== "future" && (
                <div className={"d-flex gap-3 justify-content-center"}>
                  <ButtonWithoutIcon
                    btnText={"جزئیات قرعه کشی"}
                    type={"click"}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(
                        "/management-fan/lottery-details?page=" +
                          queryString?.page,
                        {
                          state: data.matches[row.index].id,
                        }
                      );
                    }}
                  />
                </div>
              )}
            </>
          );
        },
      },
    ],
    [queryString.page]
  );

  columns.reverse();
  // Create an instance of the useTable hook
  //@ts-ignore

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    //@ts-ignore

    exportData,
  } = useTable(
    //@ts-ignore

    { columns, data: data.matches, defaultColumn },
    useFilters,
    useSortBy,
    useExportData
  );

  return (
    <div className={"p-c-30"}>
      <div style={{ overflow: "auto" }}>
        <table
          {...getTableProps()}
          style={{
            borderCollapse: "collapse",
            columnGap: "20px",
            direction: "ltr",
            minWidth: "100%",
          }}
        >
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row, index) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()}>
                      {cell.column.id === "id" ? (
                        // Accessing row index here
                        <span className="rowNum">
                          {(queryString.page - 1) * Number(numberInPage) +
                            index +
                            1}
                        </span>
                      ) : (
                        cell.render("Cell")
                      )}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div
        className={"d-flex gap-4 py-4 my-8"}
        style={{
          borderBottom: "1px  solid #F1F1F4",
          borderTop: " 1px solid #F1F1F4",
        }}
      ></div>
      {/*Pagination start*/}
      <div style={{ marginRight: "auto" }}>
        <CustomPagination
          activePage={queryString.page}
          setQueryString={setQueryString}
          totalRows={data?.totalRows}
          numberInPage={numberInPage}
        />
      </div>
    </div>
  );
};

const HeaderTextIcon = ({ text }: { text: string }) => {
  return (
    <div
      className={"d-flex align-items-center justify-content-center gap-2"}
      style={{ whiteSpace: "nowrap", margin: "0 5px" }}
    >
      <span>{text}</span> <KTIcon iconName={"filter"} className={"fs-5"} />
    </div>
  );
};

// const IconsCell = ({ league, refetch, page }: any) => {
//   const icons = [
//     {
//       iconClass: "fc-12 color-yellow-c",
//       iconName: "pencil",
//       wrapperClass: "bg-light-yellow-c",
//     },
//     {
//       iconClass: "fc-12 color-red-c",
//       iconName: "trash",
//       wrapperClass: "bg-light-red-c",
//     },
//   ];
//   const navigate = useNavigate();
//   const [delItem, setDelItem] = React.useState<any>(null);
//   const [showDelModal, setShowDelModal] = React.useState<boolean>(false);
//   const handleActionClick = (icon: any, team: any) => {
//     if (icon.iconName === "pencil") {
//       navigate(`/leagues/edit-league?page=${page}`, { state: team });
//     } else {
//       setDelItem(() => {
//         return {
//           id: league.id,
//         };
//       });
//       setShowDelModal(true);
//     }
//   };
//   return (
//     <>

//       <div className={"IconCell"}>
//         {icons.map((icon) => (
//           <a onClick={(e) => handleActionClick(icon, league)}>
//             <SquireIconWrapper {...icon} />
//           </a>
//         ))}
//       </div>
//     </>
//   );
// };

export default LotteryTabel;
